import { bl_fi_entity_credit_term_hdr_RowClass } from '../../../dbschema/bl_fi_entity_credit_term_hdr.model';
import { BaseContainerModel } from '../../base-container.model';

export class CreditTermContainerModel extends BaseContainerModel {
    bl_fi_entity_credit_term_hdr:bl_fi_entity_credit_term_hdr_RowClass= new bl_fi_entity_credit_term_hdr_RowClass();
}